import { useAuthStore } from "~/plugins/store/auth";

export default defineNuxtRouteMiddleware((to, from) => {
    const authStore = useAuthStore();

    if (authStore.getAccessToken()) {
        let inactivityTimeout: NodeJS.Timeout | null = null;
        const maxInactivityTime = 3600 * 1000; // 1 oră de inactivitate, în milisecunde

        const handleInactivity = async () => {
            await authStore.logout();
            authStore.user = null;
            alert('You have been logged out due to inactivity.');
            navigateTo('/authenticate');
        };

        const resetInactivityTimer = () => {
            if (inactivityTimeout) {
                clearTimeout(inactivityTimeout!);
            }
            inactivityTimeout = setTimeout(handleInactivity, maxInactivityTime);
        };

        resetInactivityTimer();

        if (process.client) {
            ['click', 'mousemove', 'keydown', 'scroll'].forEach((event) => {
                window.addEventListener(event, resetInactivityTimer);
            });
        }
    }
});